import { DefaultDirections, SortProviderProps, UrlSortProvider } from '@tableau/data-catalog-shared';
import * as React from 'react';

import { DashboardOrderField, OrderDirection } from '../../../../gen-src/queries/globalTypes';

export type DashboardsValidSortFields = DashboardOrderField.NAME;

export const DashboardsDefaultDirections: DefaultDirections<DashboardsValidSortFields> = {
  [DashboardOrderField.NAME]: OrderDirection.ASC,
};

export const DashboardsDefaultSortField = DashboardOrderField.NAME;

export function DashboardsGridSortProvider(
  props: Pick<SortProviderProps<DashboardsValidSortFields>, 'children'>
): JSX.Element {
  return (
    <UrlSortProvider<DashboardsValidSortFields>
      validOrderFieldsWithDefaultDirections={DashboardsDefaultDirections}
      defaultField={DashboardsDefaultSortField}
    >
      {props.children}
    </UrlSortProvider>
  );
}
